import React from "react";

interface SVGRProps {
  title?: string;
  titleId?: string;
}

export function ArrowRightIcon({
  title = "right arrow",
  titleId,
  color = "#FFF",
  strokeWidth = 3,
  ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) {
  return (
    <svg width={10} height={14} fill="none" aria-labelledby={titleId} {...props}>
      {title ? (
        <title id={titleId} className="localize-ignore">
          {title}
        </title>
      ) : null}
      <path d="M2 12l5-5-5-5" stroke={color} strokeWidth={strokeWidth} />
    </svg>
  );
}

export function ArrowLeftIcon({ title = "right arrow", titleId, ...props }: React.SVGProps<SVGSVGElement> & SVGRProps) {
  return (
    <svg width={15} height={12} viewBox="0 0 15 12" fill="none" aria-labelledby={titleId} {...props}>
      {title ? (
        <title id={titleId} className="localize-ignore">
          {title}
        </title>
      ) : null}
      <path
        d="M.47 5.47a.75.75 0 000 1.06l4.773 4.773a.75.75 0 101.06-1.06L2.061 6l4.242-4.243a.75.75 0 00-1.06-1.06L.47 5.47zm14.03-.22H1v1.5h13.5v-1.5z"
        fill="#828282"
      />
    </svg>
  );
}

export function ArrowDownIcon({
  title = "down arrow",
  titleId,
  color = "#FFF",
  strokeWidth = 3,
  ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) {
  return (
    <svg width={12} height={8} fill="none" aria-labelledby={titleId} {...props}>
      {title ? (
        <title id={titleId} className="localize-ignore">
          {title}
        </title>
      ) : null}
      <path d="M11 0.999955L6 5.99991L1.00005 0.999953" stroke={color} strokeWidth={strokeWidth} />
    </svg>
  );
}

export function ArrowUpIcon({
  title = "up arrow",
  titleId,
  color = "#FFF",
  ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) {
  return (
    <svg width={12} height={8} fill="none" aria-labelledby={titleId} {...props}>
      {title ? (
        <title id={titleId} className="localize-ignore">
          {title}
        </title>
      ) : null}
      <path d="M1.00005 7.00005L6 2.00009L11 7.00005" stroke={color} strokeWidth={3} />
    </svg>
  );
}
